import React, { useState } from "react";
import ContractBrowser from "./ContractBrowser";
import ContractCreator from "./ContractCreator";
import "./contracts.css";

const VIEWS = [
  "Public Contracts", 
  "Private Offers", 
  "Active Contracts",
  "My Portfolio", 
  "Create Contract"
];

export default function ContractsOffice({ userData }) {
  const [viewIndex, setViewIndex] = useState(0);

  const nextView = () => setViewIndex((prev) => (prev + 1) % VIEWS.length);
  const prevView = () => setViewIndex((prev) => (prev - 1 + VIEWS.length) % VIEWS.length);

  return (
    <div className="contracts-office-wrapper" style={{ 
      display: "flex", 
      flexDirection: "column", 
      fontFamily: "'JetBrains Mono', monospace",
      background: "rgba(0, 10, 10, 0.2)",
      border: "1px solid rgba(80, 227, 194, 0.1)",
      padding: "16px"
    }}>
      
      {/* HUD-Style Navigation Bar */}
      <div className="contracts-navigation" style={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center",
        background: "rgba(80, 227, 194, 0.05)",
        padding: "10px 20px",
        border: "1px solid rgba(80, 227, 194, 0.2)",
        marginBottom: "20px"
      }}>
        <button 
          onClick={prevView} 
          className="chevron" 
          style={{ background: "transparent", border: "none", color: "#50e3c2", fontSize: "1.2rem", cursor: "pointer" }}
        > 
          ◀ 
        </button>
        
        <div style={{ textAlign: "center" }}>
          <div style={{ color: "#666", fontSize: "0.5rem", letterSpacing: "2px", marginBottom: "2px" }}>VIEW</div>
          <h2 className="view-title" style={{ margin: 0, color: "#fff", fontSize: "1rem", letterSpacing: "1px" }}>
            {VIEWS[viewIndex].toUpperCase()}
          </h2>
        </div>
        
        <button 
          onClick={nextView} 
          className="chevron" 
          style={{ background: "transparent", border: "none", color: "#50e3c2", fontSize: "1.2rem", cursor: "pointer" }}
        > 
          ▶ 
        </button>
      </div>

      {/* Content Area - Flex-Grow to fill the tall wrapper */}
      <div className="contracts-content" style={{ 
        flexGrow: 1, 
        overflowY: "auto", // Inner scrolling for long contract lists
        paddingRight: "8px" 
      }}>
        {VIEWS[viewIndex] === "Create Contract" ? (
          <ContractCreator userData={userData} onComplete={() => setViewIndex(3)} />
        ) : (
          <ContractBrowser 
            userData={userData} 
            mode={VIEWS[viewIndex]} 
          />
        )}
      </div>
    </div>
  );
}